import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Form } from "../../interfaces/forms";
import { Controller, useFormContext } from "react-hook-form";

interface DateFormProps {
  field: Form;
}

function DateForm(props: DateFormProps) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      name={props.field.name}
      control={control}
      render={({ field }) => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateTimePicker
            {...field}
            label={props.field.label}
            renderInput={(params) => {
              return (
                <TextField
                  {...field}
                  error={!!errors[props.field.name]}
                  sx={{ width: "100%" }}
                  {...params}
                  helperText={
                    errors[props.field.name]
                      ? (errors[props.field.name]?.message as string)
                      : ""
                  }
                />
              );
            }}
          />
        </LocalizationProvider>
      )}
    />
  );
}

export default DateForm;
